"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

var _bodyScrollLock = require("body-scroll-lock");

var _themeSections = require("@shopify/theme-sections");

var _themeCurrency = require("@shopify/theme-currency");

var _utils = require("../helpers/utils");

var _svgMap = require("../helpers/svg-map");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _toggle = _interopRequireDefault(require("../components/toggle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: Cart drawer
 * -----------------------------------------------------------------------------
 * Contains highly coupled scripts to render cart items onto a drawer.
 *
 * @namespace cartDrawer
 */

/**
 * DOM selectors.
 */


var selectors = {
  body: '[js-cart-drawer="body"]',
  footer: '[js-cart-drawer="footer"]',
  subtotal: '[js-ajax-cart="subtotal"]'
};
/**
 * Create a new drawer instance.
 */

var Drawer = (0, _toggle["default"])({
  toggleSelector: 'cartDrawerToggle',
  targetSelector: 'cartDrawerTarget'
});
/**
 * Register the `cart-drawer` section type.
 */

(0, _themeSections.register)('cart-drawer', {
  /**
   * Initialise section.
   */
  init: function init() {
    Drawer.init();
    this.body = document.querySelector(selectors.body);
    this.footer = document.querySelector(selectors.footer);
    this.subtotal = document.querySelector(selectors.subtotal);
  },

  /**
   * Set listeners for each instance.
   */
  setListeners: function setListeners() {
    var _this = this;

    Frame.EventBus.listen('Toggle:cartDrawerTarget:open', function () {
      (0, _bodyScrollLock.disableBodyScroll)(_this.body);

      _this.render();
    });
    Frame.EventBus.listen('Toggle:cartDrawerTarget:close', function () {
      return (0, _bodyScrollLock.enableBodyScroll)(_this.body);
    });
    Frame.EventBus.listen('AjaxCart:itemAdded', function () {
      return _this.open();
    });
    Frame.EventBus.listen(['AjaxCart:cartCleared', 'AjaxCart:itemRemoved'], function () {
      return _this.render();
    });
    Frame.EventBus.listen(['AjaxCart:removingItem'], function (item) {
      return _this.setLoadingState(item);
    });
  },

  /**
   * Render line items template.
   */
  render: function render() {
    var _this2 = this;

    (0, _utils.queryCart)().then(function (data) {
      if (data.item_count > 0) {
        _this2.setActiveState(data);

        return;
      }

      _this2.setEmptyState();

      throw new Error('Cart is empty');
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  },

  /**
  * Set active state.
  * @param {Object} data - Cart data.
  */
  setActiveState: function setActiveState(data) {
    this.body.innerHTML = this.getActiveTemplate(data.items);
    this.subtotal.innerHTML = (0, _themeCurrency.formatMoney)(data.total_price, theme.moneyFormat);
    this.footer.classList.remove(_cssClasses["default"].hidden);
    Frame.EventBus.emit('AjaxCart:reinit');
  },

  /**
   * Set loading state.
   * @param {Object} element - DOM line item.
   */
  setLoadingState: function setLoadingState(element) {
    element.classList.add(_cssClasses["default"].removing);
  },

  /**
  * Set empty state.
  */
  setEmptyState: function setEmptyState() {
    this.body.innerHTML = this.getEmptyTemplate();
    this.footer.classList.add(_cssClasses["default"].hidden);
  },

  /**
  * Get cart drawer body template.
  * @param {Object} items - Cart line item object data.
  * @returns {string} - Template string.
  */
  getActiveTemplate: function getActiveTemplate(items) {
    var _this3 = this;

    return items.map(function (item) {
      return _this3.getLineItemTemplate(item);
    }).join('');
  },

  /**
   * Get empty cart template.
   */
  getEmptyTemplate: function getEmptyTemplate() {
    return "<p>".concat(theme.strings.cart.general.empty, "</p>");
  },

  /**
   * Get line item template.
   * @param {Object} item - Cart line item object data.
   * @returns {string} - Template.
   */
  setSubscriptionParentUrl: function setSubscriptionParentUrl(item) {
    return item.properties !== null && item.properties._parent_url !== null ? item.properties._parent_url : item.url;
  },
  setSubscriptionParentImage: function setSubscriptionParentImage(item) {
    return item.properties !== null && item.properties._parent_image !== null ? item.properties._parent_image : item.image;
  },
  getLineItemTemplate: function getLineItemTemplate(item) {
    var itemUrl = this.setSubscriptionParentUrl(item) === undefined ? item.url : this.setSubscriptionParentUrl(item);
    var itemImage = this.setSubscriptionParentImage(item) === undefined ? item.image : this.setSubscriptionParentImage(item);
    var isPodPresent = item.properties._hasPointOfDemand;
    return "\n      <div class=\"ajax-cart__line-item\" js-ajax-cart=\"lineItem\" js-product-handle=\"".concat(item.handle, "\">\n        <div class=\"ajax-cart__line-item-content\">\n          <div class=\"ajax-cart__image responsive-image__wrapper\">\n            <img\n              src=\"").concat(itemImage, "\"\n              srcset=\"").concat(itemImage, " 300w, ").concat(itemImage, " 700w, ").concat(itemImage, " 1000w\"\n              alt=\"").concat(item.title, "\"\n            >\n          </div>\n\n          <div class=\"ajax-cart__description\">\n            ").concat(this.getTag(item), "\n\n            <a class=\"ajax-cart__title h6\" href=\"").concat(itemUrl, "\">\n              ").concat(this.getProductTitle(item), "\n            </a>\n\n            <p class=\"ajax-cart__qty\">Qty ").concat(item.quantity, "</p>\n\n            <div class=\"ajax-cart__price\" data-label=\"Price\">\n              ").concat(this.getLinePrice(item), "\n              ").concat(this.getOriginalLinePrice(item), "\n            </div>\n\n            <small class=\"ajax-cart__icon-remove\" js-ajax-cart=\"remove\" data-key=\"").concat(item.key, "\" tabindex=\"0\">").concat(_svgMap.misc.remove, "</small>\n          </div>\n          </div>\n        \n        ").concat(isPodPresent ? "\n          <div class=\"ajax-cart__pod-message\">\n            <div class=\"ajax-cart__pod-message-container\">\n              <svg class=\"icon icon__print-point-on-demand\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 19 18\">\n                <mask id=\"a\" width=\"19\" height=\"18\" x=\"0\" y=\"0\" fill=\"#000\" maskUnits=\"userSpaceOnUse\">\n                  <path fill=\"#fff\" d=\"M0 0h19v18H0z\"/>\n                  <path fill-rule=\"evenodd\" d=\"M4.611 4.564H1.879c-.48 0-.879.384-.879.857v7.39c0 .473.399.857.88.857H4.61v3.047c0 .157.129.285.293.285h9.198a.288.288 0 0 0 .293-.285v-3.047h2.726c.486 0 .879-.384.879-.857v-7.39a.868.868 0 0 0-.88-.857h-2.725V1.286A.288.288 0 0 0 14.102 1H4.904a.288.288 0 0 0-.293.286v3.278Zm9.198 5.772v6.093H5.197v-6.093h8.612ZM6.72 15.279h5.563a.288.288 0 0 0 .294-.285.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .158.13.285.293.285Zm0-1.611h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.285H6.72a.288.288 0 0 0-.293.285c0 .158.13.286.293.286Zm7.674-.571h2.726a.288.288 0 0 0 .293-.286v-7.39a.288.288 0 0 0-.293-.286H1.879a.292.292 0 0 0-.293.286v7.39c0 .158.135.286.293.286h2.732V10.05c0-.158.129-.285.293-.285h9.198c.164 0 .293.127.293.285v3.047Zm-7.674-1.04h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .157.13.285.293.285Zm7.088-7.493V1.571H5.197v2.993h8.612Z\" clip-rule=\"evenodd\"/>\n                </mask>\n                <path fill=\"#000\" fill-rule=\"evenodd\" d=\"M4.611 4.564H1.879c-.48 0-.879.384-.879.857v7.39c0 .473.399.857.88.857H4.61v3.047c0 .157.129.285.293.285h9.198a.288.288 0 0 0 .293-.285v-3.047h2.726c.486 0 .879-.384.879-.857v-7.39a.868.868 0 0 0-.88-.857h-2.725V1.286A.288.288 0 0 0 14.102 1H4.904a.288.288 0 0 0-.293.286v3.278Zm9.198 5.772v6.093H5.197v-6.093h8.612ZM6.72 15.279h5.563a.288.288 0 0 0 .294-.285.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .158.13.285.293.285Zm0-1.611h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.285H6.72a.288.288 0 0 0-.293.285c0 .158.13.286.293.286Zm7.674-.571h2.726a.288.288 0 0 0 .293-.286v-7.39a.288.288 0 0 0-.293-.286H1.879a.292.292 0 0 0-.293.286v7.39c0 .158.135.286.293.286h2.732V10.05c0-.158.129-.285.293-.285h9.198c.164 0 .293.127.293.285v3.047Zm-7.674-1.04h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .157.13.285.293.285Zm7.088-7.493V1.571H5.197v2.993h8.612Z\" clip-rule=\"evenodd\"/>\n                <path fill=\"#000\" d=\"M4.611 4.564v.15h.15v-.15h-.15Zm0 9.104h.15v-.15h-.15v.15Zm9.784 0v-.15h-.15v.15h.15Zm0-9.104h-.15v.15h.15v-.15Zm-.586 5.772h.15v-.15h-.15v.15Zm0 6.093v.15h.15v-.15h-.15Zm-8.612 0h-.15v.15h.15v-.15Zm0-6.093v-.15h-.15v.15h.15Zm9.198 2.76h-.15v.15h.15v-.15Zm-9.784 0v.15h.15v-.15h-.15Zm9.198-8.532v.15h.15v-.15h-.15Zm0-2.993h.15v-.15h-.15v.15Zm-8.612 0v-.15h-.15v.15h.15Zm0 2.993h-.15v.15h.15v-.15Zm-.586-.15H1.879v.3h2.732v-.3Zm-2.732 0C1.32 4.414.85 4.861.85 5.421h.3c0-.386.327-.707.73-.707v-.3ZM.85 5.421v7.39h.3v-7.39h-.3Zm0 7.39c0 .56.47 1.007 1.03 1.007v-.3a.722.722 0 0 1-.73-.707h-.3Zm1.03 1.007H4.61v-.3H1.879v.3Zm2.581-.15v3.047h.3v-3.047h-.3Zm0 3.047c0 .243.199.435.443.435v-.3a.138.138 0 0 1-.143-.136h-.3Zm.443.435h9.198v-.3H4.904v.3Zm9.198 0a.438.438 0 0 0 .443-.435h-.3a.138.138 0 0 1-.143.135v.3Zm.443-.435v-3.047h-.3v3.047h.3Zm-.15-2.897h2.726v-.3h-2.726v.3Zm2.726 0c.566 0 1.029-.447 1.029-1.007h-.3a.718.718 0 0 1-.73.707v.3Zm1.029-1.007v-7.39h-.3v7.39h.3Zm0-7.39c0-.56-.463-1.007-1.03-1.007v.3c.408 0 .73.32.73.707h.3Zm-1.03-1.007h-2.725v.3h2.726v-.3Zm-2.575.15V1.286h-.3v3.278h.3Zm0-3.278c0-.244-.2-.436-.443-.436v.3c.084 0 .143.064.143.136h.3ZM14.102.85H4.904v.3h9.198v-.3Zm-9.198 0a.438.438 0 0 0-.443.436h.3c0-.072.059-.136.143-.136v-.3Zm-.443.436v3.278h.3V1.286h-.3Zm9.198 9.05v6.093h.3v-6.093h-.3Zm.15 5.943H5.197v.3h8.612v-.3Zm-8.462.15v-6.093h-.3v6.093h.3Zm-.15-5.943h8.612v-.3H5.197v.3Zm1.524 4.943h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.435h-.3a.138.138 0 0 1-.144.135v.3Zm.444-.435c0-.243-.2-.436-.444-.436v.3c.085 0 .144.064.144.136h.3Zm-.444-.436H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.436h.3c0-.072.06-.136.143-.136v-.3Zm-.443.436c0 .243.2.435.443.435v-.3a.138.138 0 0 1-.143-.135h-.3Zm.443-1.176h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.436h-.3a.138.138 0 0 1-.144.136v.3Zm.444-.436c0-.243-.2-.435-.444-.435v.3c.085 0 .144.063.144.135h.3Zm-.444-.435H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.435h.3c0-.072.06-.135.143-.135v-.3Zm-.443.435c0 .244.2.436.443.436v-.3a.138.138 0 0 1-.143-.136h-.3Zm8.117-.135h2.726v-.3h-2.726v.3Zm2.726 0a.438.438 0 0 0 .443-.436h-.3a.138.138 0 0 1-.143.136v.3Zm.443-.436v-7.39h-.3v7.39h.3Zm0-7.39c0-.244-.2-.436-.443-.436v.3c.084 0 .143.064.143.136h.3Zm-.443-.436H1.879v.3h15.242v-.3Zm-15.242 0a.442.442 0 0 0-.443.436h.3c0-.07.063-.136.143-.136v-.3Zm-.443.436v7.39h.3v-7.39h-.3Zm0 7.39c0 .245.207.436.443.436v-.3a.142.142 0 0 1-.143-.136h-.3Zm.443.436h2.732v-.3H1.879v.3Zm2.882-.15V10.05h-.3v3.047h.3Zm0-3.047c0-.072.059-.135.143-.135v-.3a.438.438 0 0 0-.443.435h.3Zm.143-.135h9.198v-.3H4.904v.3Zm9.198 0c.084 0 .143.063.143.135h.3c0-.244-.2-.435-.443-.435v.3Zm.143.135v3.047h.3V10.05h-.3ZM6.72 12.206h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.435h-.3a.138.138 0 0 1-.144.135v.3Zm.444-.435c0-.244-.2-.436-.444-.436v.3c.085 0 .144.064.144.136h.3Zm-.444-.436H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.436h.3c0-.072.06-.136.143-.136v-.3Zm-.443.436c0 .243.2.435.443.435v-.3a.138.138 0 0 1-.143-.135h-.3Zm7.68-7.207V1.571h-.3v2.993h.3Zm-.15-3.143h-8.61v.3h8.61v-.3Zm-8.76.15v2.993h.3V1.571h-.3Zm.15 3.143h8.61v-.3h-8.61v.3Z\" mask=\"url(#a)\"/>\n              </svg>\n\n              <span>".concat(theme.strings.printOnDemand, "</span>\n            </div>\n          </div>\n        ") : '', "\n\n        ").concat(this.alreadyPurchasedAlert(item), "\n      </div>\n    ");
  },

  /**
   * Get product title.
   * @param {object} item - Line item data object.
   * @returns {string}
   */
  getProductTitle: function getProductTitle(item) {
    if (item.properties && item.properties.prepaid_subscription === 'true') {
      return "".concat(item.product_title, " - ").concat(theme.strings.cart.label.prepaidSubscription);
    }

    return item.product_title;
  },

  /**
   * Get tag.
   * @param {object} item - Line item data object.
   */
  getTag: function getTag(item) {
    var hasLoyaltyDiscountTag = item.tags.find(function (tag) {
      return tag.startsWith('manual-loyalty:');
    });

    if (theme.loyalty.loyaltyDiscountEnable && theme.isLoyaltyCustomer && hasLoyaltyDiscountTag && item.properties._compare_at_price === '') {
      return "\n        <span class=\"ajax-cart__tag h6\">\n          ".concat(window.theme.strings.collections.general.loyaltyBadgeTitle, "\n        </span>\n      ");
    } else if (item.discounts.length > 0) {
      return "<span class=\"ajax-cart__tag h6\">".concat(item.discounts[0].title, "</span>");
    } else {
      return '';
    }
  },

  /**
   * Get line item price.
   * @param {Object} items - Cart line item object data.
   * @returns {string}
   */
  getLinePrice: function getLinePrice(item) {
    return "".concat((0, _themeCurrency.formatMoney)(item.line_price, theme.moneyFormat));
  },

  /**
   * Get original line item price.
   * @param {Object} items -  Cart line item object data.
   * @returns {string}
   */
  getOriginalLinePrice: function getOriginalLinePrice(item) {
    if (item.properties._compare_at_price !== '') {
      return "\n        <span class=\"ajax-cart__price--original\">\n          <s>".concat((0, _themeCurrency.formatMoney)(item.properties._compare_at_price * item.quantity, theme.moneyFormat), "</s>\n        </span>\n      ");
    } else if (item.discounts.length > 0) {
      return "<span class=\"ajax-cart__price--original\"><s>".concat((0, _themeCurrency.formatMoney)(item.original_line_price, theme.moneyFormat), "</s></span>");
    } else {
      return '';
    }
  },

  /**
   * Get variant titles.
   * @param {Object} item - Cart line item object data.
   * @returns {string} - Variant title string.
   */
  getVariantTitle: function getVariantTitle(item) {
    return this.isVariantTitle(item) ? "<p class=\"ajax-cart__variant\">".concat(item.variant_title, "</p>") : '';
  },

  /**
   * Shows alert if ebook has been purchased in the past.
   * @param {Object} item - Cart line item object data.
   * @returns {string} - Ebook already purchased alert.
   */
  alreadyPurchasedAlert: function alreadyPurchasedAlert(item) {
    return window.orderedBooks && window.orderedBooks.includes(item.variant_id.toString()) ? "<p class=\"\n          ebook-alert\n          ebook-alert--cart\n        \">\n          ".concat(theme.strings.ebooks.ebookAlertCart, "\n        </p>") : '';
  },

  /**
   * Check if variant title exists.
   * @param {Object} item - Cart line item object data.
   */
  isVariantTitle: function isVariantTitle(item) {
    return item.variant_options.length && !item.variant_options[0].includes('Default Title');
  },

  /**
   * Open drawer and force render.
   */
  open: function open() {
    Drawer.open();
    this.render();
  },

  /**
   * Callback function when section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
   */
  onLoad: function onLoad() {
    this.init();
    this.setListeners();
  }
});